import { drawPatternBackground, PatternBackgroundOptions } from "../../utils/background_pattern_utils.js";
import { UIElement } from "./ui_element.js";

export interface UIPatternCanvasOptions
{
  pattern_image: ImageBitmap;
  tile_size?: number;
  tile_width?: number;
  tile_height?: number;
  background_color?: string;
  tile_opacity?: number;
}

export class UIPatternCanvas extends UIElement
{
  private readonly canvas: HTMLCanvasElement;
  private readonly options: UIPatternCanvasOptions;

  public constructor(
    ctx: CanvasRenderingContext2D,
    x: number,
    y: number,
    w: number,
    h: number,
    options: UIPatternCanvasOptions
  )
  {
    super( ctx, x, y, w, h, false, false );

    this.options = options;
    this.canvas = this.buildPatternCanvas();
  }

  private buildPatternCanvas(): HTMLCanvasElement
  {
    const canvas = document.createElement( "canvas" );
    canvas.width = Math.max( 1, Math.floor( this.rect.getW() ) );
    canvas.height = Math.max( 1, Math.floor( this.rect.getH() ) );

    const bg_ctx = canvas.getContext( "2d" );
    if ( !bg_ctx )
      return canvas;

    const pattern_options: PatternBackgroundOptions = {
      tile_size: this.options.tile_size,
      tile_width: this.options.tile_width,
      tile_height: this.options.tile_height,
      background_color: this.options.background_color
    };

    drawPatternBackground(
      bg_ctx,
      this.options.pattern_image,
      0,
      0,
      canvas.width,
      canvas.height,
      pattern_options
    );

    return canvas;
  }

  private dom_mounted = false;

  protected override syncDomContent( _node: HTMLElement ): boolean
  {
    if ( !this.dom_mounted )
    {
      this.dom_mounted = true;
      const c = this.canvas;
      c.style.position = "absolute";
      c.style.left = "0";
      c.style.top = "0";
      c.style.width = `${this.rect.getW()}px`;
      c.style.height = `${this.rect.getH()}px`;
      c.style.imageRendering = "auto";
      c.style.pointerEvents = "none";
      c.style.opacity = `${this.options.tile_opacity ?? 1}`;
      this.getDomSkin().appendChild( c );
    }
    return true;
  }

  public render(): void
  {
    if ( !this.shouldBeRendered() )
      return;

    this.startRender();

    this.ctx.save();

    this.ctx.globalAlpha = this.options.tile_opacity ?? 1;

    this.ctx.drawImage(
      this.canvas,
      -this.getRect().getW2(),
      -this.getRect().getH2()
    );

    this.ctx.restore();

    this.finishRender();
  }

  public name(): string
  {
    return "UIPatternCanvas";
  }
}